import { render, staticRenderFns } from "./CoordinacionWebGuiasComponent.vue?vue&type=template&id=00701916&"
import script from "./CoordinacionWebGuiasComponent.vue?vue&type=script&lang=js&"
export * from "./CoordinacionWebGuiasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports